/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/dialogs/domain-suggestions/app.dialogs.domain-suggestions.component.ts.
 */
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomainSuggestion} from '../../models/domain-suggestion';
import {AppMobileService} from '../../services/app.mobile.service';

/**
 * Zweck: Beschreibt class AppDialogsDomainSuggestionsComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'app.dialogs.domain-suggestions.component.html',
    styleUrls: ['app.dialogs.domain-suggestions.component.scss'],
    standalone: false
})
export class AppDialogsDomainSuggestionsComponent {

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public dialogRef: MatDialogRef<AppDialogsDomainSuggestionsComponent>,
              @Inject(MAT_DIALOG_DATA) public suggestions: DomainSuggestion[], public msvc: AppMobileService) {
  }
}
